import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const ArrowsExpandIcon = ({
  width = "16",
  height = "16",
  color = "#1C3C6C",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.66667 14V12.6667H4.27333L7.27333 9.66667L6.33333 8.72667L3.33333 11.7267V9.33333H2V14H6.66667ZM9.66667 7.27333L12.6667 4.27333V6.66667H14V2H9.33333V3.33333H11.7267L8.72667 6.33333L9.66667 7.27333Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
